import React, {Component} from "react";
import moment from "moment";
import {map, reduce} from "lodash";
import {Button, Icon} from "antd";
import {
  displayRecapPaymentCsvFile, displayRecapPaymentPdfFile,
  getRecapByDay
} from "../../../actions/thunks/statistics";
import {setFilterInvoicesByDay} from "../../../actions/actions/statistics";
import {connect} from "react-redux";
import { Tabs } from 'antd';
import {formatAmount} from "utils";
import _ from "i18n";

const { TabPane } = Tabs;

class RecapByDate extends Component {


  constructor(props) {
    super(props);

    this.state = {

      date : 'jour'
    };
  }

  componentDidMount() {
    if(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0) {
      this.props.getRecapByDay(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null , this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.statisticsFilter.year && this.props.statisticsFilter.year.length > 0 ? this.props.statisticsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }


  componentDidUpdate(prevProps, prevState)
  {

    if((prevProps.operationType !== this.props.operationType) && this.props.operationType !== null) {

      this.props.getRecapByDay(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null , this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.statisticsFilter.year && this.props.statisticsFilter.year.length > 0 ? this.props.statisticsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }


  constructMonthBloc = ({amount, month}) => {

    return (
      <div>

        <div className="flex flex-row justify-between">
          <div className={this.props.recapByDay.filterDay == month ? "div-day-recap div-day-recap-active":"div-day-recap"} onClick={() => {
            this.setDayFilter(month)}}>
            {moment(month).format("MM/YYYY")}
          </div>
          <div className=" self-end pr-4  div-recap-amount">
            {formatAmount(amount)}
          </div>
        </div>
        <div className="line"/>
      </div>
    )

  }

  constructDayBloc = ({amount, day}) => {

    return (
      <div>

        <div className="flex flex-row justify-between">
          <div className={this.props.recapByDay.filterDay == day? "div-day-recap div-day-recap-active":"div-day-recap"} onClick={() => {
            this.setDayFilter(day)}}>
            {moment(day).format("DD/MM/YYYY")}
          </div>
          <div className=" self-end pr-4  div-recap-amount">
            {formatAmount(amount)}
          </div>
        </div>
        <div className="line"/>
      </div>
    )

  }

  calculSum = () => {
    return reduce(this.props.recapByDay.items['month'], (sum, { amount }) => (sum + parseInt(amount)), 0);
  }


  toggleDayChecked = () => {

    this.props.setFilterInvoicesByDay(null)
  }

  setDayFilter = (date) => {

    this.props.setFilterInvoicesByDay(date)
  }

  getCsvFile = () => {
    this.props.changeState(true);
    this.props.displayRecapPaymentCsvFile(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null, this.state.date, this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.statisticsFilter.year && this.props.statisticsFilter.year.length > 0 ? this.props.statisticsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : []).then((res) => {
      this.props.changeState(false);
    });
  }

  getPdfFile = () => {
    this.props.changeState(true);
    this.props.displayRecapPaymentPdfFile(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null, this.state.date, this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.statisticsFilter.year && this.props.statisticsFilter.year.length > 0 ? this.props.statisticsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : []).then((res) => {
      this.props.changeState(false);
    });
  }

  callback = (key) => {

    this.setState({date : key});
  }
  render() {

    let {recapByDay} = this.props;

    if(!recapByDay || !recapByDay.items['month'] || recapByDay.items.length === 0) {

      return <div>

      </div>
    }

    return (
      <div  className="recap-day-container pl-4">

        <div className="flex flex-row justify-between align-center pt-8" >

          <div className="recap-day-title">
            {_('Date')}
          </div>

        </div>
        <div className="pt-8 mb-2">

          <Button  type={recapByDay.filterDay === null ? 'primary' : 'default'} data-operation="ALL" onClick={() => this.toggleDayChecked()}>{_('ALL')} </Button>

        </div>


        <div className="flex relative">

          <Tabs onChange={this.callback} type="card">
            <TabPane tab=" Jour " key="jour">
              <div className="pt-4 scroll-div-recap w-48">
                {recapByDay.items['jour'] && recapByDay.items['jour'] != null ? map(recapByDay.items['jour'], this.constructDayBloc) : null}
              </div>
            </TabPane>
            <TabPane tab=" Mois" key="month">
              <div className="pt-4 scroll-div-recap w-48">
                { recapByDay.items['month'] && recapByDay.items['month']!== null ? map(recapByDay.items['month'], this.constructMonthBloc) : null }
              </div>
            </TabPane>
          </Tabs>
          <div className="flex pt-3 absolute " style={{right: '0'}}>
            <div className="ml-2" style={{cursor: 'pointer'}} onClick={this.getCsvFile}>
              <Icon type="file-excel" style={{ fontSize: '20px', color: '#2495e1' }} />
            </div>

            <div className="ml-2" style={{cursor: 'pointer'}} onClick={this.getPdfFile}>
              <Icon type="file-pdf" style={{ fontSize: '20px', color: '#2495e1' }} />
            </div>

          </div>

        </div>
        <div className="flex flex-row justify-between pt-4  pr-4 pb-4">
          <div className="border-right-line"> TOTAL</div>
          <div className="div-recap-amount-total"> { formatAmount(this.calculSum()) } </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  statisticsFilter: state.filters.statisticsFilter,
  recapByDay: state.recapByDay,
  auth: state.auth,
});

const mapDispatchToProps = {
  getRecapByDay,
  setFilterInvoicesByDay,
  displayRecapPaymentCsvFile,
  displayRecapPaymentPdfFile
};

export default connect(mapStateToProps, mapDispatchToProps)(RecapByDate);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/RecapByDate.js